module.exports = __webpack_public_path__ + "static/media/propic-third.51019728.png";